import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { IrisDmsFolderActionsMenuComponent } from '@iris/common/modules/dms/components/actions/folder-actions-menu/folder-actions-menu.component';
import { IrisDmsDownloadFolderButtonComponent } from '@iris/common/modules/dms/components/actions/folder-actions/dms-download-folder-button/dms-download-folder-button.component';
import { IrisDmsEditFolderButtonComponent } from '@iris/common/modules/dms/components/actions/folder-actions/dms-edit-folder-button/dms-edit-folder-button.component';
import { IrisDmsFolderActionType, IrisDMSFolderI } from '@iris/common/modules/dms/models/IrisDMSFolder';
import { IrisDmsPermissionsSandbox } from '@iris/common/modules/dms/sandbox/dms-permissions.sandbox';
import { filter, take, tap } from 'rxjs';
import { StrakitClickStopPropagationDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-folder-grid-actions',
  imports: [
    IrisDmsEditFolderButtonComponent,
    IrisDmsFolderActionsMenuComponent,
    IrisDmsDownloadFolderButtonComponent,
    StrakitClickStopPropagationDirective,
  ],
  templateUrl: './folder-grid-actions.component.html',
  styleUrls: ['./folder-grid-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class IrisDmsFolderGridActionsComponent {
  private readonly dmsPermissionsSandbox = inject(IrisDmsPermissionsSandbox);

  readonly folder = input<IrisDMSFolderI>();
  readonly showActionsMenu = input(true);

  readonly disabledFolderActions = [IrisDmsFolderActionType.Download, IrisDmsFolderActionType.Edit];

  readonly folderId = computed(() => this.folder()?.id);
  readonly folderId$ = toObservable(this.folderId);
  readonly isProjectFolder = computed(() => this.folder()?.isProjectFolder);

  readonly hasUpdatePermission = computed(() => {
    if (!this.folderId()) {
      return false;
    }
    return this.dmsPermissionsSandbox.hasUpdatePermissionForFolderId(this.folderId())();
  });

  constructor() {
    this.folderId$.pipe(
      filter(Boolean),
      take(1),
      tap(folderId => this.dmsPermissionsSandbox.getUserAvailableActions(folderId)),
    ).subscribe();
  }
}
